//
//
//
//
//
//
//
//
//
//
//
//

export default {
    methods: {
        animateSprite ({ element, event }) {
            element.animationSpeed = 0.1;
            element.loop = false;
            element.interactive = false;
        }
    }
};
